import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import ResourceSelect from "../../../../../../components/Inputs/ResourceSelect";
import { 
    renderSettingsResourceLabel, 
    getSettingsResourceSearchFilters 
} from "../../../../../../utils/helpers/settings";

export const useEmploymentTypeFilter = () => {
    const { t } = useTranslation();

    return useMemo(
        () => ({
            name: "employmentType",
            label: t("employment-type"),
            type: "resource-select",
            component: (
                <ResourceSelect
                    resourcePath="/user-demographic/employment-type"
                    mode="multiple"
                    renderLabel={renderSettingsResourceLabel}
                    getSearchFilters={getSettingsResourceSearchFilters}
                    hasSearch
                />
            ),
        }),
        [t]
    );
};
